import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

/* eslint-disable react/no-deprecated */
import React, { Component } from 'react';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import { isLikeText } from '../Translate';
import Heading from '../Heading';
import Button from '../Button';
import { isClickable } from '../utils';

/**
 * `Panel` component is used for visually grouping some content.
 * @since 0.0.35
 */
var Panel =
/*#__PURE__*/
function (_Component) {
  _inherits(Panel, _Component);

  function Panel(props) {
    var _this;

    _classCallCheck(this, Panel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Panel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "handleToggle", function (e) {
      if (isClickable(e)) {
        return;
      }

      _this.setState(function (_ref) {
        var collapsed = _ref.collapsed;
        return {
          collapsed: !collapsed
        };
      }, function () {
        if (_this.props.onToggle) {
          _this.props.onToggle(_this.state.collapsed);
        }
      });
    });

    var _collapsed2 = _this.props.collapsible && _this.props.collapsed || false; // eslint-disable-next-line react/state-in-constructor


    _this.state = {
      collapsed: _collapsed2,
      prevPropsCollapsed: _collapsed2
    };
    return _this;
  }

  _createClass(Panel, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          baseClassName = _this$props.baseClassName,
          className = _this$props.className,
          title = _this$props.title,
          collapsible = _this$props.collapsible,
          _collapsed = _this$props.collapsed,
          onToggle = _this$props.onToggle,
          children = _this$props.children,
          extra = _this$props.extra,
          props = _objectWithoutProperties(_this$props, ["baseClassName", "className", "title", "collapsible", "collapsed", "onToggle", "children", "extra"]);

      var collapsed = this.state.collapsed;
      var handleToggle = collapsible ? this.handleToggle : undefined;
      return React.createElement("div", _extends({
        className: classNames(baseClassName, (_classNames = {}, _defineProperty(_classNames, "".concat(baseClassName, "--collapsible"), collapsible), _defineProperty(_classNames, "".concat(baseClassName, "--collapsed"), collapsed), _defineProperty(_classNames, "".concat(baseClassName, "--expanded"), !collapsed), _classNames), className)
      }, props), title && React.createElement("div", {
        className: "".concat(baseClassName, "__header"),
        onClick: handleToggle
      }, isLikeText(title) ? React.createElement(Heading, {
        component: "div",
        level: 4,
        className: "".concat(baseClassName, "__title")
      }, title) : title, (extra || collapsible) && React.createElement("div", {
        className: "".concat(baseClassName, "__extra")
      }, extra, collapsible && React.createElement(Button, {
        ghost: true,
        className: "".concat(baseClassName, "__control-button"),
        icon: {
          name: 'chevron-up',
          flipVertical: collapsed
        },
        onClick: handleToggle
      }))), React.createElement("div", {
        className: "".concat(baseClassName, "__content")
      }, children));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      if (props.collapsed !== state.prevPropsCollapsed) {
        return {
          collapsed: props.collapsed,
          prevPropsCollapsed: props.collapsed
        };
      }

      return null;
    }
  }]);

  return Panel;
}(Component);

_defineProperty(Panel, "defaultProps", {
  collapsible: false,
  collapsed: false,
  baseClassName: "".concat(CLS_PREFIX, "panel")
});

export default Panel;